import { THEME } from '../../../../components-v2/Theme/theme';

/** Shared tooltip panel chrome for Opportunity advanced reporting charts (theme tokens only). */
export const opportunityChartTooltipChrome = {
	background: THEME.colors.background.light,
	border: THEME.common.border,
	borderRadius: THEME.common.borderRadius,
	padding: THEME.spacing.sm,
	boxShadow: `0 1px 3px ${THEME.colors.border.main}`,
} as const;
